// Navigation Actions
 export const addToCart = (product) => ({
    type: "ADD_TO_CART",
    product
  })

  export const removeFromCart = (id) => ({
    type: "REMOVE_FROM_CART",
    id
  })

  export const clearCart = () => ({
    type: "CLEAR_CART",
  })

  export const setQuantity = (id, quantity) => ({
    type: "SET_QUANTITY",
    id,
    quantity,
  })